import R from 'ramda'

const SEND_DARK_TWEET_ACTION_TYPE = 'SEND_DARK_TWEET'
const SEND_DARK_TWEET_DISPLAY_TYPE = 'Send Tweet'

const isSendDarkTweetWidgetAction = R.propEq(
  'type',
  SEND_DARK_TWEET_ACTION_TYPE
)

const convertSendDarkTweetWidgetActionToFormAction = R.pipe(
  R.applySpec({
    type: R.always(SEND_DARK_TWEET_DISPLAY_TYPE),
    message: R.prop('message'),
    attachmentUrl: R.prop('attachmentUrl'),
    cardUri: R.prop('cardUri'),
    media: R.prop('media'),
    isPromotedTweet: R.T,
    tweetMediaIds: R.ifElse(
      R.prop('isRandomResponse'),
      R.propOr([], 'tweetMediaIds'),
      R.always(undefined)
    ),
    randomResponsePoolId: R.ifElse(
      R.prop('isRandomResponse'),
      R.propOr('', 'randomResponsePoolId'),
      R.always(undefined)
    ),
    randomResponseTweetIds: R.ifElse(
      R.prop('isRandomResponse'),
      R.propOr([], 'randomResponseTweetIds'),
      R.always(undefined)
    ),
    allowMultiple: R.ifElse(
      R.prop('isRandomResponse'),
      R.propOr(false, 'allowMultiple'),
      R.always(undefined)
    ),
    isRandomResponse: R.ifElse(
      R.prop('isRandomResponse'),
      R.prop('isRandomResponse'),
      R.always(undefined)
    ),
    isMosaicConsent: R.ifElse(
      R.prop('isMosaicConsent'),
      R.prop('isMosaicConsent'),
      R.always(undefined)
    ),
    hasResponseCap: R.ifElse(
      R.prop('responseCap'),
      R.always(true),
      R.always(undefined)
    ),
    responseCap: R.ifElse(
      R.prop('responseCap'),
      R.pipe(R.prop('responseCap'), R.toString),
      R.always(undefined)
    ),
    isSequential: R.ifElse(
      R.prop('isSequential'),
      R.always(true),
      R.always(undefined)
    ),
    allowResponseTriggers: R.ifElse(
      R.prop('allowResponseTriggers'),
      R.always(true),
      R.always(undefined)
    )
  }),
  R.pickBy(R.complement(R.isNil))
)

export {
  isSendDarkTweetWidgetAction,
  convertSendDarkTweetWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/send-dark-tweet.js